import type { NavigationGuardNext, RouteLocationNormalized } from 'vue-router'
import { useAuthStore } from '@/stores/auth'

export const agreementGuard = (
  to: RouteLocationNormalized,
  from: RouteLocationNormalized,
  next: NavigationGuardNext
) => {
  const authStore = useAuthStore()
  
  // Allow login and error pages
  if (to.path === '/login' || to.path.startsWith('/error')) {
    next()
    return
  }
  
  // Check if agreement is signed
  if (authStore.isAuthenticated && !authStore.user?.agreementSigned) {
    next(false)
    return
  }
  
  next()
}

export const authGuard = async (
  to: RouteLocationNormalized,
  from: RouteLocationNormalized,
  next: NavigationGuardNext
) => {
  const authStore = useAuthStore()
  
  if (!authStore.isAuthenticated) {
    // Try to fetch user if not already authenticated
    await authStore.fetchUser()
    
    if (!authStore.isAuthenticated) {
      next('/login')
      return
    }
  }
  
  next()
}

export const groupGuard = (
  to: RouteLocationNormalized,
  from: RouteLocationNormalized,
  next: NavigationGuardNext
) => {
  const authStore = useAuthStore()
  
  // Check if route requires specific groups
  if (to.meta.allowedGroups && Array.isArray(to.meta.allowedGroups)) {
    const userGroups = authStore.userGroups
    const requiredGroups = to.meta.allowedGroups as string[]
    
    // Admin users can access everything
    if (userGroups.includes('admin')) {
      next()
      return
    }
    
    // Check if user has any of the required groups
    const hasAccess = authStore.hasAnyGroup(requiredGroups)
    
    if (!hasAccess) {
      console.warn(`Access denied to ${to.path}. Required groups: ${requiredGroups.join(', ')}. User groups: ${userGroups.join(', ')}`)
      next('/unauthorized')
      return
    }
  }
  
  next()
}

export const guestOnlyGuard = (
  to: RouteLocationNormalized,
  from: RouteLocationNormalized,
  next: NavigationGuardNext
) => {
  const authStore = useAuthStore()
  
  if (authStore.isAuthenticated) {
    next('/home')
    return
  }
  
  next()
}